export default [
  { id: 'ab', name: 'аҧсуа бызшәа, аҧсшәа' },
  { id: 'aa', name: 'Afaraf' },
  { id: 'af', name: 'Afrikaans' },
  { id: 'ak', name: 'Akan' },
  { id: 'sq', name: 'Shqip' },
  { id: 'am', name: 'አማርኛ' },
  { id: 'ar', name: 'العربية' },
  { id: 'an', name: 'aragonés' },
  { id: 'hy', name: 'Հայերեն' },
  { id: 'as', name: 'অসমীয়া' },
  { id: 'av', name: 'авар мацӀ, магӀарул мацӀ' },
  { id: 'ae', name: 'avesta' },
  { id: 'ay', name: 'aymar aru' },
  { id: 'az', name: 'azərbaycan dili' },
  { id: 'bm', name: 'bamanankan' },
  { id: 'ba', name: 'башҡорт теле' },
  { id: 'eu', name: 'euskara, euskera' },
  { id: 'be', name: 'беларуская мова' },
  { id: 'bn', name: 'বাংলা' },
  { id: 'bh', name: 'भोजपुरी' },
  { id: 'bi', name: 'Bislama' },
  { id: 'bs', name: 'bosanski jezik' },
  { id: 'br', name: 'brezhoneg' },
  { id: 'bg', name: 'български език' },
  { id: 'my', name: 'ဗမာစာ' },
  { id: 'ca', name: 'català, valencià' },
  { id: 'ch', name: 'Chamoru' },
  { id: 'ce', name: 'нохчийн мотт' },
  { id: 'ny', name: 'chiCheŵa, chinyanja' },
  { id: 'cv', name: 'чӑваш чӗлхи' },
  { id: 'kw', name: 'Kernewek' },
  { id: 'co', name: 'corsu, lingua corsa' },
  { id: 'cr', name: 'ᓀᐦᐃᔭᐍᐏᐣ' },
  { id: 'hr', name: 'hrvatski jezik' },
  { id: 'cs', name: 'čeština, český jazyk' },
  { id: 'da', name: 'dansk' },
  { id: 'dv', name: 'ދިވެހި' },
  { id: 'nl', name: 'Nederlands, Vlaams' },
  { id: 'dz', name: 'རྫོང་ཁ' },
  { id: 'en', name: 'English' },
  { id: 'eo', name: 'Esperanto' },
  { id: 'et', name: 'eesti, eesti keel' },
  { id: 'ee', name: 'Eʋegbe' },
  { id: 'fo', name: 'føroyskt' },
  { id: 'fj', name: 'vosa Vakaviti' },
  { id: 'fi', name: 'suomi, suomen kieli' },
  { id: 'fr', name: 'français, langue française' },
  { id: 'ff', name: 'Fulfulde, Pulaar, Pular' },
  { id: 'gl', name: 'Galego' },
  { id: 'ka', name: 'ქართული' },
  { id: 'de', name: 'Deutsch' },
  { id: 'el', name: 'ελληνικά' },
  { id: 'gn', name: "Avañe'ẽ" },
  { id: 'gu', name: 'ગુજરાતી' },
  { id: 'ht', name: 'Kreyòl ayisyen' },
  { id: 'ha', name: '(Hausa) هَوُسَ' },
  { id: 'he', name: 'עברית' },
  { id: 'hz', name: 'Otjiherero' },
  { id: 'hi', name: 'हिन्दी, हिंदी' },
  { id: 'ho', name: 'Hiri Motu' },
  { id: 'hu', name: 'magyar' },
  { id: 'ia', name: 'Interlingua' },
  { id: 'id', name: 'Bahasa Indonesia' },
  { id: 'ga', name: 'Gaeilge' },
  { id: 'ig', name: 'Asụsụ Igbo' },
  { id: 'ik', name: 'Iñupiaq, Iñupiatun' },
  { id: 'io', name: 'Ido' },
  { id: 'is', name: 'Íslenska' },
  { id: 'it', name: 'Italiano' },
  { id: 'iu', name: 'ᐃᓄᒃᑎᑐᑦ' },
  { id: 'jv', name: 'ꦧꦱꦗꦮ, Basa Jawa' },
  { id: 'kl', name: 'kalaallisut, kalaallit oqaasii' },
  { id: 'kn', name: 'ಕನ್ನಡ' },
  { id: 'kr', name: 'Kanuri' },
  { id: 'kk', name: 'қазақ тілі' },
  { id: 'km', name: 'ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ' },
  { id: 'ki', name: 'Gĩkũyũ' },
  { id: 'rw', name: 'Ikinyarwanda' },
  { id: 'ky', name: 'Кыргызча, Кыргыз тили' },
  { id: 'kv', name: 'коми кыв' },
  { id: 'kg', name: 'Kikongo' },
  { id: 'kj', name: 'Kuanyama' },
  { id: 'la', name: 'latine, lingua latina' },
  { id: 'lb', name: 'Lëtzebuergesch' },
  { id: 'lg', name: 'Luganda' },
  { id: 'li', name: 'Limburgs' },
  { id: 'ln', name: 'Lingála' },
  { id: 'lo', name: 'ພາສາລາວ' },
  { id: 'lt', name: 'lietuvių kalba' },
  { id: 'lv', name: 'latviešu valoda' },
  { id: 'gv', name: 'Gaelg, Gailck' },
  { id: 'mk', name: 'македонски јазик' },
  { id: 'mg', name: 'fiteny malagasy' },
  { id: 'ml', name: 'മലയാളം' },
  { id: 'mt', name: 'Malti' },
  { id: 'mi', name: 'te reo Māori' },
  { id: 'mr', name: 'मराठी' },
  { id: 'mh', name: 'Kajin M̧ajeļ' },
  { id: 'mn', name: 'Монгол хэл' },
  { id: 'na', name: 'Dorerin Naoero' },
  { id: 'nv', name: 'Diné bizaad' },
  { id: 'nd', name: 'isiNdebele' },
  { id: 'ne', name: 'नेपाली' },
  { id: 'ng', name: 'Owambo' },
  { id: 'nb', name: 'Norsk Bokmål' },
  { id: 'nn', name: 'Norsk Nynorsk' },
  { id: 'no', name: 'Norsk' },
  { id: 'ii', name: 'ꆈꌠ꒿ Nuosuhxop' },
  { id: 'nr', name: 'isiNdebele' },
  { id: 'oc', name: "occitan, lenga d'òc" },
  { id: 'oj', name: 'ᐊᓂᔑᓈᐯᒧᐎᓐ' },
  { id: 'cu', name: 'ѩзыкъ словѣньскъ' },
  { id: 'om', name: 'Afaan Oromoo' },
  { id: 'or', name: 'ଓଡ଼ିଆ' },
  { id: 'os', name: 'ирон æвзаг' },
  { id: 'pi', name: 'पालि, पाळि' },
  { id: 'fa', name: 'فارسی' },
  { id: 'pl', name: 'język polski, polszczyzna' },
  { id: 'ps', name: 'پښتو' },
  { id: 'pt', name: 'Português' },
  { id: 'qu', name: 'Runa Simi, Kichwa' },
  { id: 'rm', name: 'Rumantsch Grischun' },
  { id: 'rn', name: 'Ikirundi' },
  { id: 'ro', name: 'Română' },
  { id: 'ru', name: 'русский' },
  { id: 'sa', name: 'संस्कृतम्' },
  { id: 'sc', name: 'sardu' },
  { id: 'se', name: 'Davvisámegiella' },
  { id: 'sm', name: "gagana fa'a Samoa" },
  { id: 'sg', name: 'yângâ tî sängö' },
  { id: 'sr', name: 'српски језик' },
  { id: 'gd', name: 'Gàidhlig' },
  { id: 'sn', name: 'chiShona' },
  { id: 'si', name: 'සිංහල' },
  { id: 'sk', name: 'Slovenčina, Slovenský Jazyk' },
  { id: 'sl', name: 'Slovenski Jezik, Slovenščina' },
  { id: 'so', name: 'Soomaaliga, af Soomaali' },
  { id: 'st', name: 'Sesotho' },
  { id: 'es', name: 'Español' },
  { id: 'su', name: 'Basa Sunda' },
  { id: 'sw', name: 'Kiswahili' },
  { id: 'ss', name: 'SiSwati' },
  { id: 'sv', name: 'Svenska' },
  { id: 'ta', name: 'தமிழ்' },
  { id: 'te', name: 'తెలుగు' },
  { id: 'th', name: 'ไทย' },
  { id: 'ti', name: 'ትግርኛ' },
  { id: 'bo', name: 'བོད་ཡིག' },
  { id: 'tk', name: 'Türkmen, Түркмен' },
  { id: 'tl', name: 'Wikang Tagalog' },
  { id: 'tn', name: 'Setswana' },
  { id: 'to', name: 'Faka Tonga' },
  { id: 'tr', name: 'Türkçe' },
  { id: 'ts', name: 'Xitsonga' },
  { id: 'tw', name: 'Twi' },
  { id: 'ty', name: 'Reo Tahiti' },
  { id: 'uk', name: 'Українська' },
  { id: 'ur', name: 'اردو' },
  { id: 've', name: 'Tshivenḓa' },
  { id: 'vi', name: 'Tiếng Việt' },
  { id: 'vo', name: 'Volapük' },
  { id: 'wa', name: 'Walon' },
  { id: 'cy', name: 'Cymraeg' },
  { id: 'wo', name: 'Wollof' },
  { id: 'fy', name: 'Frysk' },
  { id: 'xh', name: 'isiXhosa' },
  { id: 'yi', name: 'ייִדיש' },
  { id: 'yo', name: 'Yorùbá' },
  { id: 'za', name: 'Saɯ cueŋƅ, Saw cuengh' },
  { id: 'zu', name: 'isiZulu' },
];
